import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";

export type StatusFilterValue = "ASSIGNED" | "PENDING_HANDOVER" | "LOADED" | "DELIVERING" | null;

const PARAM_NAME = "status";

export function useStatusFilter() {
  const [searchParams, setSearchParams] = useSearchParams();
  const value = (searchParams.get(PARAM_NAME) as StatusFilterValue) ?? null;

  const setValue = useCallback(
    (next: StatusFilterValue) => {
      const updated = new URLSearchParams(searchParams);
      if (next) {
        updated.set(PARAM_NAME, next);
      } else {
        updated.delete(PARAM_NAME);
      }
      setSearchParams(updated, { replace: true });
    },
    [searchParams, setSearchParams],
  );

  return { value, setValue };
}
